import { MotionGlobalConfig } from "framer-motion";

/**
 * Honour `prefers-reduced-motion` fully. framer-motion's `reducedMotion="user"` drops transform/layout animation but
 * deliberately keeps opacity fades, so content still fades in (and axe on slow CI measured half-faded colours).
 * With the preference on, every framer animation jumps to its end state; it follows live preference changes.
 */
export function syncReducedMotion(win: Pick<Window, "matchMedia"> | undefined = typeof window === "undefined" ? undefined : window) {
  const mq = win?.matchMedia?.("(prefers-reduced-motion: reduce)");
  if (!mq) return () => undefined;
  const apply = () => {
    MotionGlobalConfig.skipAnimations = mq.matches;
  };
  apply();
  mq.addEventListener?.("change", apply);
  return () => mq.removeEventListener?.("change", apply);
}
